import {
  useMutation,
  type UseMutationOptions,
} from "@tanstack/react-query"
import type { AuthSession } from "../../domain/entities/auth"
import { makeLogin } from "../../domain/use-cases/login"
import { httpAuthRepository } from "../../data/repositories/auth-repository"

const login = makeLogin(httpAuthRepository)

type Credentials = { email: string; password: string }

export const useLogin = (
  options?: Omit<
    UseMutationOptions<AuthSession, Error, Credentials>,
    "mutationFn"
  >
) =>
  useMutation({
    ...options,
    mutationFn: (credentials: Credentials) => login(credentials),
  })
